export default __webpack_public_path__ + "static/media/IMG_6523-1point-5-768x510.1d0a77a4.jpg";